export default __webpack_public_path__ + "static/media/DealerManagement.87fc23b2.png";